import { render, staticRenderFns } from "./RadarCharts.vue?vue&type=template&id=cabc81e4&scoped=true"
import script from "./RadarCharts.vue?vue&type=script&lang=js"
export * from "./RadarCharts.vue?vue&type=script&lang=js"
import style0 from "./RadarCharts.vue?vue&type=style&index=0&id=cabc81e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabc81e4",
  null
  
)

export default component.exports